export const CHARIOT_AJOUT_ARTICLE = "CHARIOT_AJOUT_ARTICLE";
export const CHARIOT_AJOUT_REQUETTE = "CHARIOT_AJOUT_REQUETTE";
export const CHARIOT_SUPP_ARTICLE = "CHARIOT_SUPP_ARTICLE";
export const CHARIOT_LIVRAISON_ADRESSE = "CHARIOT_LIVRAISON_ADRESSE";
export const CHARIOT_SAVE_METHODE_PAIEMENT = "CHARIOT_SAVE_METHODE_PAIEMENT";
export const CHARIOT_SAVE_DATE_LIVRAISON = "CHARIOT_SAVE_DATE_LIVRAISON";
export const CHARIOT_RESET = "CHARIOT_RESET";
export const CHARIOT_SAVE_VARIABLE_GLOB = "CHARIOT_SAVE_VARIABLE_GLOB";
export const CHARIOT_TOTALE_PRIX = "CHARIOT_TOTALE_PRIX";
